var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useRef, useState } from 'react';
import { BaseInput } from './base-input';
export var ColorPicker = function (_a) {
    var id = _a.id, name = _a.name, value = _a.value, onChange = _a.onChange, error = _a.error, label = _a.label, props = __rest(_a, ["id", "name", "value", "onChange", "error", "label"]);
    var _b = useState(value), hexValue = _b[0], setHexValue = _b[1];
    var _c = useState(1), alphaValue = _c[0], setAlphaValue = _c[1];
    var _d = useState(false), isOpen = _d[0], setIsOpen = _d[1];
    var colorPickerRef = useRef(null);
    var containerRef = useRef(null);
    var handleColorChange = function (e) {
        var newValue = e.target.value;
        setHexValue(newValue);
        onChange(e);
    };
    var handleAlphaChange = function (e) {
        var newValue = parseFloat(e.target.value);
        setAlphaValue(newValue);
        // Get hex value of alpha value
        var alphaHex = Math.round(newValue * 255).toString(16);
        setHexValue(function (prevValue) {
            var hexValue = prevValue.slice(0, 7);
            return "".concat(hexValue).concat(alphaHex);
        });
        // Update the color value with the new alpha value in hex format
        onChange({
            target: { name: name, value: "".concat(hexValue.slice(0, 7)).concat(alphaHex) },
        });
    };
    var handleOnColorPickerClick = function () {
        if (colorPickerRef.current) {
            colorPickerRef.current.click();
            setIsOpen(true);
        }
    };
    // Close dropdown when clicking outside
    useEffect(function () {
        var handleClickOutside = function (event) {
            if (containerRef.current && !containerRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return function () {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);
    useEffect(function () {
        setHexValue(value);
    }, [value]);
    return (_jsxs("div", { ref: containerRef, className: 'relative w-full h-full', children: [label && (_jsx("label", { htmlFor: id, className: 'block text-sm font-medium text-gray-700 mb-1', children: label })), _jsxs("div", { className: "\n          flex items-center h-full border rounded-md transition-all duration-200 ease-in-out\n          ".concat(error ? 'border-vjwDanger' : 'border-gray-300', "\n          ").concat(isOpen ? 'ring-2 ring-vjwPrimary' : 'hover:border-gray-400', "\n        "), onClick: handleOnColorPickerClick, children: [_jsx("div", { className: 'w-10 h-full rounded-l-md border-r', style: {
                            backgroundColor: hexValue,
                            borderColor: error ? '#EF4444' : 'inherit',
                        } }), _jsx(BaseInput, __assign({ ref: colorPickerRef, type: 'color', id: id, name: name, hasError: !!error, value: hexValue, className: 'absolute opacity-0 w-0 h-0', onChange: handleColorChange }, props)), _jsxs("div", { className: 'flex px-1 py-2 w-full flex-col', children: [_jsx("input", { type: 'text', readOnly: true, value: hexValue === null || hexValue === void 0 ? void 0 : hexValue.toUpperCase(), className: '\n            w-full bg-transparent \n            text-gray-900 text-sm \n            focus:outline-none cursor-pointer\n          ', "aria-label": 'Color Value', role: 'button', tabIndex: 0, onClick: handleOnColorPickerClick }), _jsx("input", { type: 'range', min: '0', max: '1', step: '0.1', className: 'w-20', value: alphaValue, onChange: handleAlphaChange, "aria-label": 'Alpha Value' })] }), _jsx("button", { type: 'button', onClick: handleOnColorPickerClick, className: '\n            px-3 py-2 bg-gray-50 h-full border-l \n            hover:bg-vjwSecondary focus:outline-none\n            transition-colors duration-200\n          ', "aria-label": 'Open Color Picker', children: _jsx("svg", { xmlns: 'http://www.w3.org/2000/svg', className: 'w-5 h-5 text-gray-600', fill: 'none', viewBox: '0 0 24 24', stroke: 'currentColor', children: _jsx("path", { strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: 2, d: 'M7 21a4 4 0 01-4-4V5a2 2 0 012-2h4a2 2 0 012 2v12a4 4 0 01-4 4zm0 0h12a2 2 0 002-2v-4a2 2 0 00-2-2h-2.343M11 7.343l1.657-1.657a2 2 0 012.828 0l2.829 2.829a2 2 0 010 2.828l-8.486 8.485M7 17h.01' }) }) })] }), error && typeof error === 'string' && _jsx("p", { className: 'mt-1 text-sm text-red-600', children: error })] }));
};
